<template>
  <LoginGuard>
    <div class="container">
      <o-section-dashboard-menu :items="items" />
    </div>
  </LoginGuard>
</template>

<script>
import LoginGuard from "../vue-ocom/auth/components/LoginGuard";
import MENU_ITEMS from "./menu_items";
import OSectionDashboardMenu from '@/vue-ocom/components/layout/app/OSectionDashboardMenu';

export default {
  components: {
    LoginGuard,
    OSectionDashboardMenu,
  },
  data: () => ({
    items: MENU_ITEMS,
  }),
};
</script>
